import { render, staticRenderFns } from "./order-item-details-link-attachment.vue?vue&type=template&id=083fd990"
import script from "./order-item-details-link-attachment.vue?vue&type=script&lang=js"
export * from "./order-item-details-link-attachment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports